import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";

import { APICore } from "../helpers/api/apiCore";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useDispatch } from "react-redux";
import { account } from "../redux/actions";
//const stripePromise = loadStripe('pk_test_51JTRriLgIbmluKyLSUjK9Orjfbhe4amY6tjY2LhgYH5XLIthKHXsl7b0TxwQtgfrfNX0cBsGWATDznC42jlhsdsU00k5ciksqp');

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: Component, roles, ...rest }) => {
  const [host, setHost] = useState();
  const api = new APICore();
  const dispatch = useDispatch();
  useEffect(() => {
    // resetAuth()
    const domainName = window.location.hostname; //3f9603b6c2bf
    const hosti = domainName.split(".")[0];

    //console.log(hosti); // "reactgo.com"

    setHost(hosti);

    if (hosti) {
      dispatch(account(hosti));
    }
  }, []);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (api.isUserAuthenticated() === false) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }

       // const loggedInUser = api.getLoggedInUser();

        // check if route is restricted by role
        // if (roles && roles.indexOf(loggedInUser.role) === -1) {
        //   // role not authorised so redirect to home page
        //   return <Redirect to={{ pathname: "/" }} />;
        // }
        // authorised so return component
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
